import { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import Images from './Images';
import { BadgeCheck, Camera } from 'lucide-react';

interface ProfileAvatarProps {
  image?: string;

  username?: string;

  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';

  showUsername?: boolean;

  className?: string;

  imageClassName?: string;

  usernameClassName?: string;

  children?: ReactNode;
  fallbackSrc?: string;
  isVerified?: boolean;
  isCamera?: boolean;
}

const sizeClasses = {
  xs: {
    wrapper: 'w-6 h-6',
    text: 'text-xs',
  },
  sm: {
    wrapper: 'w-12 h-12',
    text: 'text-xs',
  },
  md: {
    wrapper: 'w-16 h-16',
    text: 'text-sm',
  },
  lg: {
    wrapper: 'w-24 h-24',
    text: 'text-base',
  },
  xl: {
    wrapper: 'w-32 h-32',
    text: 'text-lg',
  },
};

export function ProfileAvatar({
  image = '/home/profile.png',

  username,

  size = 'md',

  showUsername = true,

  className,

  imageClassName,

  usernameClassName,

  children,

  fallbackSrc,
  isVerified = false,
  isCamera = false,
}: ProfileAvatarProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center', className)}>
      {/* IMAGE */}
      <div className="relative">
        <div
          className={cn(
            `
      relative
      rounded-full
      overflow-hidden
      border-2
      
      shrink-0
    `,
            isVerified ? 'border-green-500' : 'border-white/20',
            sizeClasses[size].wrapper,
            imageClassName
          )}
        >
          <Images
            src={image}
            alt={username || 'profile'}
            className="w-full h-full object-contain"
            fallbackSrc={fallbackSrc}
          />
        </div>
        {isCamera && (
          <div className="absolute bottom-0 -right-2 flex h-6 w-6 items-center justify-center rounded-full bg-btn-gradient2 z-20">
            <Camera size={14} className="text-white" />
          </div>
        )}
      </div>
      <div className="flex gap-1  items-end">
        {/* USERNAME */}
        {showUsername && username && (
          <p
            className={cn(
              'mt-2 text-white/80 font-medium',
              sizeClasses[size].text,
              usernameClassName
            )}
          >
            {username}
          </p>
        )}
        {isVerified && <BadgeCheck color="#11e815" strokeWidth={1.75} />}
      </div>

      {/* EXTRA CONTENT */}
      {children}
    </div>
  );
}
